import { createActionGroup, props } from '@ngrx/store';
import { CommandProgress } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CommandProgressApiActions = createActionGroup({
  source: 'Command Progress API',
  events: {
    'Command Progress loaded': props<{ commandProgresses: CommandProgress[] }>(),
    'Command Progress loaded error': props<{ error: ErrorModel }>(),
    'Command Queued': props<{ commandProgress: CommandProgress }>(),
  },
});

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CommandProgressSignalRActions = createActionGroup({
  source: 'CommandProgress SignalR Hub',
  events: {
    'Command Progress received': props<{ commandProgress: CommandProgress }>(),
  },
});

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CommandProgressResolverActions = createActionGroup({
  source: 'Command Progress resolver',
  events: {
    'Command Progress requested': props<{ udid: string; page: number }>(),
  },
});
